import { useCallback, useEffect, useState } from "react";

export default function usePersistentFacetSearch({
  items,
  isFromSearch,
  searchForItems,
}) {
  const [query, setQuery] = useState("");
  const [searchedItems, setSearchedItems] = useState(items);

  // A refinement refresh can clear Algolia's facet-search results
  useEffect(() => {
    if (query && !isFromSearch) {
      searchForItems(query);
    }
  }, [isFromSearch, query, searchForItems]);

  // Keep the last filtered list visible while that refresh is in flight
  useEffect(() => {
    if (!query || isFromSearch) {
      setSearchedItems(items);
    }
  }, [isFromSearch, items, query]);

  const updateQuery = useCallback(
    (value) => {
      setQuery(value);
      searchForItems(value);
    },
    [searchForItems]
  );

  return {
    query,
    updateQuery,
    visibleItems: query ? searchedItems : items,
    isSearching: Boolean(query) || isFromSearch,
  };
}
